import { Suspense, lazy } from "react";
import { observer } from "mobx-react-lite";
import storeCountry from "GlobalStores/Cores/County/StoreCountry";

const importBanner = () => {
    const country = storeCountry.CountryLowerCase();
    return import(`./country/${country}Banner.js`).catch(() => import('./DefaultBanner.js'));
};

const DynamicBanner = lazy(() => importBanner());

const Banner = observer(() => {
    return (
        <Suspense fallback={null}>
            <DynamicBanner />
        </Suspense>
    );
});

export default Banner;